// import {
//     DEMO_STAY_LISTINGS,
//   } from "data/listings";
import React, { useEffect, FC, Fragment, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
// import ButtonSecondary from "shared/Button/ButtonSecondary";
//   import SocialsList from "shared/SocialsList/SocialsList";
import { Helmet } from "react-helmet";
//   import { StayDataType } from "data/types";
//   import PropertyCardH from "components/PropertyCardH/PropertyCardH";
//   import { useLocation } from 'react-router-dom';
//   import { AuthorType } from "data/types";
//   import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import { useAuth0 } from "@auth0/auth0-react";
//   import Label from "components/Label/Label";
import Input from "shared/Input/Input";


import axios from 'axios';
import { Dialog, Transition } from "@headlessui/react";
// import { PHOTOS } from "containers/ListingDetailPage/listing-stay-detail/constant";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import ButtonSquareFull from "shared/Button/ButtonSqareFull";
import Overview from "containers/ListingDetailPage/listing-stay-detail/Overview";
import FactsFeatures from "containers/ListingDetailPage/listing-stay-detail/FactsFeatures";
import Label from "components/Label/Label";
import Textarea from "shared/Textarea/Textarea";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ListingDataType, AuthorType } from "data/types";
import ListingPropertyCard from "components/PropertyCardH/ListingPropertyCard";
import { Link, useNavigate } from 'react-router-dom';
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Modal from "../../components/ListingImageGallery/components/Modal";
import type { ListingGalleryImage } from "../../components/ListingImageGallery/utils/types";
import ReactS3Client from 'react-aws-s3-typescript';
import { s3Config } from '../../utils/s3Config';
import RentalValue from "containers/ListingDetailPage/listing-stay-detail/RentalValue";
import Neighborhood from "containers/ListingDetailPage/listing-stay-detail/Neighborhood";

export interface AuthorPageProps {
    className?: string;
}


const ListingProfile: FC<AuthorPageProps> = ({ className = "" }) => {
    const { user, isAuthenticated } = useAuth0();
    // const dotenv = require('dotenv');
    // const env = dotenv.config();
    // const accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
    // const secretAccessKey = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
    // const region = process.env.REACT_APP_AWS_REGION;
    // const bucket = process.env.REACT_APP_BUCKETNAME;

    // const s3 = new AWS.S3({
    //     accessKeyId: accessKeyId,
    //     secretAccessKey: secretAccessKey,
    //     region: region
    //   });
    //   let [categories] = useState(["Stays", "Experiences", "Car for rent"]);
    //   const DEMO_DATA: StayDataType[] = DEMO_STAY_LISTINGS.filter((_, i) => i < 4);
    //    const location = useLocation();
    // const author = location.state as AuthorType;
    // const config = {
    //     bucketName: bucket,
    //     region: region,
    //     accessKeyId: accessKeyId,
    //     secretAccessKey: secretAccessKey,
    // }


    // const DEMO_STAYS = DEMO_STAY_LISTINGS.filter((_, i) => i < 12);
    // const DEMO_DATA: StayDataType[] = DEMO_STAY_LISTINGS.filter((_, i) => i < 12);
    let [isOpenModalDetails, setIsOpenModalDetails] = useState(false);
    let [isOpenModalTour, setIsOpenModalTour] = useState(false);
    let [isOpenModalContact, setIsOpenModalContact] = useState(false);
    let [isTypePerson, setIsTypePerson] = useState(true);
    let [isOpenGallery, setIsOpenGallery] = useState(false);
    let [propertyImage, setPropertyImage] = useState<ListingGalleryImage[]>();
    // const [startDate, setStartDate] = useState(new Date());
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [modalPropertyData, setModalPropertyData] = useState<ListingDataType>();
    const [properties, setProperties] = useState<ListingDataType[]>([]);
    // const [author, setAuthor] = useState<AuthorType>();
    // const [selectedFile, setSelectedFile] = useState(null);
    const [author, setAuthor] = useState<AuthorType>();

    // Function to update the author state
    const updateAuthor = (updatedData: Partial<AuthorType>) => {
        setAuthor((prevAuthor) => {
            if (!prevAuthor) {
                // If the state is undefined, initialize the object with the updated data
                return { ...updatedData } as AuthorType;
            }
            return { ...prevAuthor, ...updatedData };
        });
    };

    const [agent, setAgent] = useState<AuthorType>();
    const navigate = useNavigate();


    function openModalDetails() {
        setIsOpenModalDetails(true);
    }

    function closeModalDetails() {
        setIsOpenModalDetails(false);
    }


    const handleAddPropertyClick = () => {
        // Navigate to the "add-listing-1" route
       // window.location.href = '/add-listing-1';
    //    <Link to={{ pathname: '/add-listing-1', agent: agent }}></Link>;
    //    {agent && (
    //     <Link to={{ pathname: '/add-listing-1', agent }}>
    //     </Link>
    //   )}
    // const history = useHistory();
    // history.push({
    //     pathname: '/add-listing-1',
    //     state:  agent ,
    //   });
    const property = {
        "address": "",
        "price": "",
        "type": "",
        "mainFeatures": [],
        "sqrft": 0,
        "isRental": false,
        "overview": {
          "description": "",
          "openDate": "",
          "openHour": "",
          "sourceMls": "",
          "mls": "",
          "lastUpdate": "",
          "map": {
            "lat": 0,
            "lng": 0
          }
        }
      } as ListingDataType
      // setProperty(propertyStep1);
  
      const propertyInfo = {
        property,
        agent,
      };
  
      navigate('/add-listing-1', { state: propertyInfo });
    };

    const renderCard = (stay: ListingDataType, index: number) => {
        return <ListingPropertyCard key={index} className="h-full" data={stay} onButtonClick={handleClick} onRefresh={handleRefresh} />;
    };

    const handleClick = (info: ListingDataType) => {
        // console.log('Button clicked???:', info);
        setModalPropertyData(info);
        setAuthor(info.author);
        const smallScreenBreakpoint = 768;
        if (window.innerWidth <= smallScreenBreakpoint) {
            navigate('/mobile-detail', { state: info });
        } else {
            openModalDetails();
        }
    };

    const handleRefresh = (info: ListingDataType) => {
        getProperties();
    };

    function closeModalTour() {
        setIsOpenModalTour(false);
    }

    function changeTypePerson() {
        setIsTypePerson(true);
    }

    function changeTypeVideo() {
        setIsTypePerson(false);
    }

    function openModalTour() {
        setIsOpenModalTour(true);
    }

    function openModalContact() {
        setIsOpenModalContact(true);
    }

    function closeModalContact() {
        setIsOpenModalContact(false);
    }

    // const handleButtonClick = (info: ListingDataType ) => {
    // //  console.log('Button clicked???:', info);
    // setModalPropertyData(info);
    // setAuthor(info.author);
    // const smallScreenBreakpoint = 768; 
    //  if (window.innerWidth <= smallScreenBreakpoint) {
    //     navigate('/mobile-detail', { state: info });
    //  } else {
    //    openModalDetails();
    //  }
    // };

    const handleOpenModalImageGallery = () => {
        const PHOTOS: string[] = modalPropertyData?.galleryImgs || [];
        const featuredImage = modalPropertyData?.featuredImage;
        const newPhotos = [featuredImage, ...PHOTOS];
        const filteredPhotos = newPhotos.filter((item) => typeof item === 'string');

        setPropertyImage(
            filteredPhotos.map((item, index): ListingGalleryImage => {
                return {
                    id: index,
                    url: typeof item === 'string' ? item : '',
                };
            })
        );
        setIsOpenGallery(true);
    };

    useEffect(() => {
        // Call the API when the component mounts
        getProperties();
        getAgentInfo();
    }, []);

    const getProperties = () => {
        // console.log(process.env.REACT_APP_AWS_ACCESS_KEY_I);
        //  console.log(accessKeyId);
        const userId = user && user.sub;
        if (userId) {
            const cleanUserId = userId.replace('auth0|', '');
            // const decodedUserId = encodeURIComponent(userId); // Encoding the user_id

            axios.get(process.env.REACT_APP_API +`agent-property/${cleanUserId}`)
                .then((response) => {
                    setProperties(response.data);
                })
                .catch((error) => {
                    // Handle any errors here
                    console.error('Error fetching properties:', error);
                });
        }
    };

    const getAgentInfo = () => {
        const userId = user && user.sub;
        if (userId) {
            const cleanUserId = userId.replace('auth0|', '');
            // const decodedUserId = encodeURIComponent(userId); // Encoding the user_id

            axios.get(process.env.REACT_APP_API +`agent/${cleanUserId}`)
                .then((response) => {
                    setAgent(response.data);
                })
                .catch((error) => {
                    // Handle any errors here
                    console.error('Error fetching properties:', error);
                });
        }
    };

    const updateAgentData = async () => {
        // Here, prepare the updatedAgentData with the required payload to send to the API

        const userId = user && user.sub;
        if (userId) {
            const cleanUserId = userId.replace('auth0|', '');
            // const decodedUserId = encodeURIComponent(userId); // Encoding the user_id

            axios.put(process.env.REACT_APP_API +`agent/${cleanUserId}`, agent)
                .then((response) => {
                    // setAgent(response.data);
                })
                .catch((error) => {
                    // Handle any errors here
                    console.error('Error fetching properties:', error);
                });
        }
    };

    const updateAgentAvatar = async (avatarUrl: string) => {
        // Here, prepare the updatedAgentData with the required payload to send to the API

        const userId = user && user.sub;
        if (userId) {
            const cleanUserId = userId.replace('auth0|', '');
            // const decodedUserId = encodeURIComponent(userId); // Encoding the user_id
            const payload = {
                id: agent?.id || '', // Assuming this is a required field
                avatar: avatarUrl || '', // Assuming this is a required field
                firstName: agent?.firstName || '',
                lastName: agent?.lastName || '',
                phoneNumber: agent?.phoneNumber || '',
                facebook: agent?.facebook || '',
                youtube: agent?.youtube || '',
                instagram: agent?.instagram || '',
                company: agent?.company || '',
                language: agent?.language || ''
                // Other agent fields go here...
            };
            axios.put(process.env.REACT_APP_API +`agent/${cleanUserId}`, payload)
                .then((response) => {
                    setAgent(response.data);
                })
                .catch((error) => {
                    // Handle any errors here
                    console.error('Error fetching properties:', error);
                });
        }
    };

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files && event.target.files[0];
        const s3 = new ReactS3Client({
            ...s3Config,
            dirName: 'profiles'
        });


        if (file) {
            try {
                // const res = await s3.uploadFile(file, filename);
                const res = await s3.uploadFile(file);
                //console.log(res);
                if (agent) {
                  
                    updateAgentAvatar(res.location);
                }
                // updateAgentData();

            } catch (exception) {
                console.log(exception);
            }
        }
    };

   

    const renderGallery = () => {
        return (
            <div className="flex flex-col ">

                <div className="relative flex-col w-full h-[400px] rounded-sm overflow-hidden cursor-pointer bg-[white] mb-[2px]">
                    <img
                        className="absolute inset-0 object-cover rounded-sm sm:rounded-sm w-full h-full"
                        src={modalPropertyData?.featuredImage}
                        alt=""
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
                        onClick={handleOpenModalImageGallery}
                    />
                    {/* <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div> */}
                </div>
                <div className=" grid grid-cols-2 gap-[2px] scroll-top-0  ">

                    {modalPropertyData?.galleryImgs?.map((item, index) => (
                        <div
                            key={index}
                            onClick={handleOpenModalImageGallery}
                            className={`relative rounded-sm overflow-hidden ${index >= 3 ? "hidden sm:block" : ""
                                }`}
                        >
                            <div className="aspect-w-6 aspect-h-3 sm:aspect-w-6 sm:aspect-h-3">
                                <img
                                    className="absolute inset-0 object-cover rounded-sm  w-full h-full"
                                    src={item || ""}
                                    alt=""

                                />
                            </div>

                            {/* OVERLAY */}
                            <div
                                className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"

                            />
                        </div>
                    ))}

                    {/* <button
        className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 hover:bg-neutral-200 z-10"
        
      >
        <Squares2X2Icon className="w-5 h-5" />
        <span className="ml-2 text-neutral-800 text-sm font-medium">
          Show all photos
        </span>
      </button> */}
                </div>
            </div>
        );
    };

    const renderTienIch = () => {
        return (
            <div className="inline-grid grid-cols-3 gap-2 py-[10px]">
                <div className="flex items-center space-x-2">
                    <span className="hidden sm:inline-block">
                        <i className="las la-bed text-lg"></i>
                    </span>
                    <span className="text-xs text-neutral-500 dark:text-neutral-400">
                        {modalPropertyData?.bedrooms} beds
                    </span>
                </div>

                {/* ---- */}
                <div className="flex items-center space-x-2">
                    <span className="hidden sm:inline-block">
                        <i className="las la-bath text-lg"></i>
                    </span>
                    <span className="text-xs text-neutral-500 dark:text-neutral-400">
                        {modalPropertyData?.bathrooms} baths
                    </span>
                </div>

                {/* ---- */}
                <div className="flex items-center space-x-2">
                    <span className="hidden sm:inline-block">
                        <i className="las la-expand-arrows-alt text-lg"></i>
                    </span>
                    <span className="text-xs text-neutral-500 dark:text-neutral-400">
                        {modalPropertyData?.sqrft} Sq. Fit
                    </span>
                </div>
            </div>
        );
    };

    const renderMainFeatures = (features: string[] | undefined) => {
        // const features = propertyObject.mainFeatures
        if (!features) {
            return null; // or <div>No data available</div> or any other alternative
        }
        return (
            <div className="flex flex-col">
                {features.map((data, index) => (
                    <div key={index} className="flex flex-row">
                        {index % 2 === 0 && (
                            <>
                                <div className="flex-col prose sm:prose w-1/2">
                                    <ul className="text-xs text-left">
                                        <li>{data}</li>
                                    </ul>
                                </div>
                                {features[index + 1] && (
                                    <div className="flex-col prose sm:prose w-1/2">
                                        <ul className="text-xs text-left">
                                            <li>{features[index + 1]}</li>
                                        </ul>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                ))}
            </div>
        );
    };

    const renderSidebar = () => {
        return (
            <div className="py-[20px] ">

                <div className="flex justify-between pb-[10px] ">
                    <span className="text-3xl ">

                        {modalPropertyData?.price}
                    </span>
                </div>
                <div className="flex flex-col ">
                    <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                        {renderTienIch()}
                    </div>
                    <div className="flex flex-col  pt-[5px] pb-[20px]">
                        {/* {isAds && <Badge name="ADS" color="green" />} */}
                        <h2 className="flex justify-left text-sm font-medium capitalize">
                            <span className="line-clamp-2">{modalPropertyData?.title}</span>
                        </h2>
                        <div className="flex justify-left text-sm font-light pt-[5px]">
                            {modalPropertyData?.address}
                        </div>
                    </div>
                    {/* host */}
                    <div className="flex items-center space-x-4 pt-[20px] pl-[35px]">
                        <Avatar
                            hasChecked
                            hasCheckedClass="w-4 h-4 -top-0.5 right-0.5"
                            sizeClass="h-20 w-20"
                            radius="rounded-full"
                            imgUrl={modalPropertyData?.author?.avatar}
                        />
                        <div >
                            {/* <a className=" text-md font-medium flex justify-left hover:no-underline" href="/author">
                        {modalPropertyData?.author.firstName} {modalPropertyData?.author.lastName}
                        </a> */}
                            <Link className=" text-md font-medium flex justify-left" to="/author" state={author}>
                                {modalPropertyData?.author?.firstName} {modalPropertyData?.author?.lastName}
                            </Link>

                            <div className=" flex items-center text-sm text-neutral-500 dark:text-neutral-400">
                                {/* <StartRating /> */}
                                {/* <FiveStartIconForRate iconClass="w-4 h-4 " className="space-x-0.5" defaultPoint={modalPropertyData?.author.reviewStart}/> */}
                                <span className="mx-2">·</span>
                            </div>
                        </div>

                    </div>
                    <div className="flex flex-row justify-left  pt-[30px]">
                        <div className="flex-col pr-[20px]">
                            <ButtonSquareFull onClick={openModalTour} className="bg-[#16385D] text-sm font-medium text-[white] px-[22px]"
                                size="h-11" >
                                Request a Tour
                            </ButtonSquareFull>
                        </div>
                        <div className="flex-col">
                            <ButtonSquareFull onClick={openModalContact} className="bg-[white] border border-[#16385D] text-sm font-medium text-[#16385D] px-[22px]"
                                size="h-11" >
                                Contact Agent
                            </ButtonSquareFull>
                        </div>
                        {renderModalTour()}
                        {renderModalContact()}
                    </div>
                    <div className="pt-[30px] ">
                        {renderMainFeatures(modalPropertyData?.mainFeatures)}
                    </div>



                    <div className="grid grid-cols-1 gap-3 mt-[35px] pb-[20px] ">
                        <div className="   rounded-lg bg-[#E3F3FF] ">
                            <Overview className="flex flex-col " overview={modalPropertyData?.overview} author={modalPropertyData?.author} />
                        </div>
                        <div className="  rounded-lg bg-[#E3F3FF]">
                            <FactsFeatures className="flex flex-col" facts={modalPropertyData?.factsFeatures} />
                            {/* <Overview className="flex flex-col " uniqueClassName="PageHome2_s2"/> */}
                        </div>
                        <div className=" rounded-lg bg-[#E3F3FF]">
             <RentalValue className="flex flex-col "  /> 
            </div>
            <div className=" rounded-lg bg-[#E3F3FF]">
             <Neighborhood className="flex flex-col "  /> 
            </div>
                        {/* {DEMO_DATA.map((item, index) => (
                      <FlightCard defaultOpen={!index} key={index} data={item} />
                    ))} */}
                    </div>
                </div>
                {/* </div> */}

                {/* SUBMIT */}
                {/* <ButtonPrimary href={"/checkout"}>Reserve</ButtonPrimary> */}
            </div>
        );
    };


    const renderModalTour = () => {
        return (
            <Transition appear show={isOpenModalTour} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 z-50 overflow-y-auto"
                    onClose={closeModalTour}
                >
                    <div className="min-h-screen px-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true"
                        >
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <div className="inline-block py-8 h-[600px] w-full max-w-sm">
                                <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white shadow-xl h-full">
                                    <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                                        <h3
                                            className="text-md font-medium leading-6 text-gray-900"
                                            id="headlessui-dialog-title-70"
                                        >
                                            Take a tour with a buyer's agent
                                        </h3>
                                        <span className="absolute left-3 top-3">
                                            <ButtonClose onClick={closeModalTour} />
                                        </span>
                                    </div>
                                    {/* <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200"> */}
                                    <div className=" px-8  text-neutral-700  ">
                                        <label className="block py-[15px]">
                                            <Label>Tour type</Label>
                                            <div className="flex justify-center w-full">
                                                <div className="inline-flex  rounded-lg py-[3px]" role="group">
                                                    <button onClick={changeTypePerson} type="button" className={`w-[160px] py-3 text-xs font-medium  rounded-l-xl  ${isTypePerson ? "text-white bg-[#1A4676] " : "text-[#1A4676] bg-white border border-[#1A4676]"}`}>
                                                        in-person
                                                    </button>
                                                    <button onClick={changeTypeVideo} type="button" className={`w-[160px] py-3 text-xs font-medium  rounded-r-xl ${isTypePerson ? "text-[#1A4676] bg-white border border-[#1A4676] " : "text-white bg-[#1A4676]"}`}>
                                                        Video chat
                                                    </button>
                                                </div>
                                            </div>
                                        </label>
                                        <div className="w-full">
                                            <label className="block">
                                                <Label>Tour date</Label>
                                                <DatePicker className="rounded-md w-[320px]"
                                                    selected={startDate}
                                                    onChange={(date) => setStartDate(date)}
                                                    minDate={new Date()}
                                                    showTimeSelect
                                                    timeFormat="HH:mm"
                                                    timeIntervals={30}
                                                    timeCaption="time"
                                                    dateFormat="MMMM d, yyyy h:mm aa"
                                                    placeholderText="Select date and time"
                                                />
                                            </label>
                                        </div>
                                        <div>
                                            <form className="grid grid-cols-1 gap-6" >
                                                <label className="block pt-[20px]">
                                                    <Label>Full name</Label>

                                                    <Input
                                                        placeholder="Type your full name"
                                                        type="text"
                                                        className="mt-1 rounded-md"
                                                    />
                                                </label>
                                                <label className="block">
                                                    <Label>Email address</Label>

                                                    <Input
                                                        type="email"
                                                        placeholder="example@example.com"
                                                        className="mt-1 rounded-md"
                                                    />
                                                </label>
                                                {/* <label className="block">
                                    <Label>Message</Label>

                                    <Textarea className="mt-1" rows={6} />
                                  </label> */}
                                                <div>
                                                    <button className="p-3 text-white font-medium  rounded-lg w-full bg-[#00D3DB]" type="submit">Request this time</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        );
    };

    const renderModalContact = () => {
        return (
            <Transition appear show={isOpenModalContact} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 z-50 overflow-y-auto"
                    onClose={closeModalContact}
                >
                    <div className="min-h-screen px-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true"
                        >
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <div className="inline-block py-8 h-[600px] w-full max-w-sm">
                                <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white shadow-xl h-full">
                                    <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                                        <h3
                                            className="text-md font-medium leading-6 text-gray-900"
                                            id="headlessui-dialog-title-70"
                                        >
                                            Contact buyer agent
                                        </h3>
                                        <span className="absolute left-3 top-3">
                                            <ButtonClose onClick={closeModalContact} />
                                        </span>
                                    </div>
                                    {/* <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200"> */}
                                    <div className=" px-8  text-neutral-700  ">
                                        <div>
                                            <form className="grid grid-cols-1 gap-6" >
                                                <label className="block pt-[20px]">
                                                    <Label>Full name</Label>

                                                    <Input
                                                        placeholder="Type your full name"
                                                        type="text"
                                                        className="mt-1 rounded-md"
                                                    />
                                                </label>
                                                <label className="block">
                                                    <Label>Email address</Label>

                                                    <Input
                                                        type="email"
                                                        placeholder="example@example.com"
                                                        className="mt-1 rounded-md"
                                                    />
                                                </label>
                                                <label className="block">
                                                    <Label>Message</Label>

                                                    <Textarea className="mt-1" rows={6} />
                                                </label>
                                                <div>
                                                    <button className="p-3 text-white font-medium  rounded-lg w-full bg-[#00D3DB]" type="submit">Send</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        );
    };
    //   const defaultProps = {
    //     center: {
    //       lat: 18.3455236,
    //       lng: -68.405473
    //     },
    //     zoom: 10
    //   };       

    const renderModalDetails = () => {
        return (
            <Transition appear show={isOpenModalDetails} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 z-50 overflow-y-auto"
                    onClose={closeModalDetails}
                >
                    <div className=" text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-xl backdrop-contrast-125 " />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true"
                        >
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <div className="inline-block  w-full max-w-6xl h-screen">
                                <div className="  flex flex-col lg:flex-row  h-full w-full overflow-hidden">
                                    <div className="relative flex-col lg:w-3/5 w-full  space-y-8 lg:space-y-10 overflow-y-auto scroll-top-0 bg-[white]">
                                        {renderGallery()}

                                    </div>

                                    <div className="flex-col bg-[white] lg:w-2/5 w-full ">
                                        <div className=" h-[30px] bg-[#D9EEFF57]">

                                        </div>
                                        <div className=" mx-[20px] h-full overflow-y-auto ">
                                            {renderSidebar()}

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        );
    };

    const renderSidebar2 = () => {
        return (
            <div className=" w-full flex flex-col items-center text-center sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8">
                <div className="relative rounded-full overflow-hidden flex">
                    <Avatar sizeClass="w-32 h-32" imgUrl={agent?.avatar} />
                    <div className="absolute inset-0 bg-black bg-opacity-30 flex flex-col items-center justify-center text-neutral-50 cursor-pointer">
                        <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M17.5 5H7.5C6.83696 5 6.20107 5.26339 5.73223 5.73223C5.26339 6.20107 5 6.83696 5 7.5V20M5 20V22.5C5 23.163 5.26339 23.7989 5.73223 24.2678C6.20107 24.7366 6.83696 25 7.5 25H22.5C23.163 25 23.7989 24.7366 24.2678 24.2678C24.7366 23.7989 25 23.163 25 22.5V17.5M5 20L10.7325 14.2675C11.2013 13.7988 11.8371 13.5355 12.5 13.5355C13.1629 13.5355 13.7987 13.7988 14.2675 14.2675L17.5 17.5M25 12.5V17.5M25 17.5L23.0175 15.5175C22.5487 15.0488 21.9129 14.7855 21.25 14.7855C20.5871 14.7855 19.9513 15.0488 19.4825 15.5175L17.5 17.5M17.5 17.5L20 20M22.5 5H27.5M25 2.5V7.5M17.5 10H17.5125"
                                stroke="currentColor"
                                strokeWidth={1.5}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>

                        <span className="mt-1 text-xs">Change Image</span>
                    </div>
                    <input
                        type="file"
                        className="absolute inset-0 opacity-0 cursor-pointer"
                        onChange={handleFileChange}
                    />
                </div>
                {isAuthenticated && <div className="space-y-2 text-center flex flex-col items-center">
                    <h2 className="text-sm font-semibold">{user?.email} </h2>
                    <span className="text-neutral-6000 text-xs">
                        Listing Agent
                    </span>
                    {/* <FiveStartIconForRate iconClass="w-4 h-4 " className="space-x-0.5" defaultPoint={author.reviewStart}/> */}
                </div>}
                {/* ---- */}


                {/* ---- */}
                {/* <p className="text-neutral-500 text-sm">
           {author.desc}
        </p> */}

                {/* ---- */}
                {/* <SocialsList
          className="!space-x-3"
          itemClass="flex items-center justify-center w-9 h-9 rounded-full bg-neutral-100 dark:bg-neutral-800 text-xl"
        /> */}

                {/* ---- */}
                {/* <div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div> */}

                {/* ---- */}
                <div className="space-y-4 w-full">
                    {/* <div className="flex items-center space-x-4"> */}
                    {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-neutral-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg> */}
                    {/* <span className="text-neutral-6000 text-sm">
               User Type: Buyer
            </span>
          </div> */}

                    <form className="grid grid-cols-1 gap-6" >

                        <label className="block ">
                            {/* <Label>Full name</Label> */}

                            <Input
                                placeholder={agent?.firstName ? agent.firstName : "First Name"}
                                value={agent?.firstName}
                                onChange={(e) => {
                                    if (agent) {
                                        setAgent({ ...agent, id: agent.id || '', firstName: e.target.value });
                                    }

                                }}
                                type="text"
                                className="mt-1 rounded-md"
                            />
                        </label>
                        <label className="block ">
                            {/* <Label>Full name</Label> */}

                            <Input
                                placeholder={agent?.lastName ? agent.lastName : "Last Name"}
                                value={agent?.lastName}
                                onChange={(e) => {
                                    if (agent) {
                                        setAgent({ ...agent, id: agent.id || '', lastName: e.target.value });
                                    }

                                }}
                                type="text"
                                className="mt-1 rounded-md"
                            />
                        </label>
                        <label className="block ">
                            {/* <Label>Full name</Label> */}

                            <Input
                                placeholder={agent?.phoneNumber ? agent.phoneNumber : "Phone Number"}
                                value={agent?.phoneNumber}
                                onChange={(e) => {
                                    if (agent) {
                                        setAgent({ ...agent, id: agent.id || '', phoneNumber: e.target.value });
                                    }

                                }}
                                type="text"
                                className="mt-1 rounded-md"
                            />
                        </label>

                        <label className="block ">
                            {/* <Label>Full name</Label> */}

                            <Input
                                placeholder={agent?.facebook ? agent.facebook : "Facebook Url"}
                                value={agent?.facebook}
                                onChange={(e) => {
                                    if (agent) {
                                        setAgent({ ...agent, id: agent.id || '', facebook: e.target.value });
                                    }

                                }}
                                type="text"
                                className="mt-1 rounded-md"
                            />
                        </label>
                        <label className="block ">
                            {/* <Label>Full name</Label> */}

                            <Input
                                placeholder={agent?.youtube ? agent.youtube : "Youtube Url"}
                                value={agent?.youtube}
                                onChange={(e) => {
                                    if (agent) {
                                        setAgent({ ...agent, id: agent.id || '', youtube: e.target.value });
                                    }

                                }}
                                type="text"
                                className="mt-1 rounded-md"
                            />
                        </label>
                        <label className="block ">
                            {/* <Label>Full name</Label> */}

                            <Input
                                placeholder={agent?.instagram ? agent.instagram : "Instagram Url"}
                                value={agent?.instagram}
                                onChange={(e) => {
                                    if (agent) {
                                        setAgent({ ...agent, id: agent.id || '', instagram: e.target.value });
                                    }

                                }}
                                type="text"
                                className="mt-1 rounded-md"
                            />
                        </label>
                        <label className="block ">
                            {/* <Label>Full name</Label> */}

                            <Input
                                placeholder={agent?.company ? agent.company : "Company"}
                                value={agent?.company}
                                onChange={(e) => {
                                    if (agent) {
                                        setAgent({ ...agent, id: agent.id || '', company: e.target.value });
                                    }

                                }}
                                type="text"
                                className="mt-1 rounded-md"
                            />
                        </label>
                        <label className="block ">
                            {/* <Label>Full name</Label> */}

                            <Input
                                placeholder={agent?.language ? agent.language : "Languages"}
                                value={agent?.language}
                                onChange={(e) => {
                                    if (agent) {
                                        setAgent({ ...agent, id: agent.id || '', language: e.target.value });
                                    }

                                }}
                                type="text"
                                className="mt-1 rounded-md"
                            />
                        </label>
                        <label className="block">
                            <Label>Message</Label>

                            <Textarea className="mt-1"
                                rows={6}
                                value={agent?.message}
                                onChange={(e) => {
                                    if (agent) {
                                        setAgent({ ...agent, id: agent.id || '', message: e.target.value });
                                    }

                                }}
                            />
                        </label>
                        <div>
                            <button className="p-3 text-white font-medium  rounded-lg w-full bg-[#00D3DB]" type="button" onClick={updateAgentData}>Update</button>
                        </div>
                    </form>
                    {/* <div className="flex items-center space-x-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-neutral-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
              />
            </svg>
            <span className="text-neutral-6000 text-sm">
            {author.language}
            </span>
          </div> */}


                    {/* <div className="flex items-center space-x-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-neutral-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span className="text-neutral-6000 text-sm">
              Joined: 
            </span>
          </div> */}
                </div>
            </div>
        );
    };



    const renderSection1 = () => {
        return (
            <div className="listingSection__wrap">
                <div className="flex justify-between ">
                    <div>
                        <h2 className="text-2xl font-semibold">My Properties</h2>

                    </div>
                    <div>
                        <ButtonSquareFull
                            className="bg-[#16385D] text-sm font-medium text-[white] px-[22px]"
                            size="h-11"
                            onClick={handleAddPropertyClick} // Call the click handler
                        >
                            Add Property
                        </ButtonSquareFull>

                    </div>

                </div>
                <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

                <div>

                    <div
                        className={`grid gap-6  md:gap-10 grid-cols-1 md:grid-cols-2 xl:grid-cols-2 sm:mx-[80px] md:mx-[0px] `}
                    >
                        {properties.map(renderCard)}
                    </div>
                    {renderModalDetails()}
                    <div className="flex mt-11 justify-center items-center">
                        {/* <ButtonSecondary>Show me more</ButtonSecondary> */}
                    </div>
                </div>
            </div>
        );
    };



    return (
        <div className={`nc-AuthorPage ${className}`} data-nc-id="AuthorPage">
            <Helmet>
                <title>Author</title>
            </Helmet>
            <main className="container mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
                <div className="block flex-grow mb-24 lg:mb-0">
                    <div className="lg:sticky lg:top-24">{renderSidebar2()}</div>
                </div>
                <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
                    {renderSection1()}
                    {isOpenGallery &&
                        <Modal
                            images={propertyImage || []}
                            onClose={() => {
                                setIsOpenGallery(false);
                            }}
                        />
                    }
                    {/* {renderSection2()} */}
                </div>
            </main>
        </div>
    );
};

export default ListingProfile;